$(document).on('click','.next-slider',function(){
    nextslider();
});

$(document).on('click','.prev-slider',function(){
    prevslider();
});

let intervalo = setInterval(nextslider,6000);

function prevslider(){
    $.each($('.slide'), function(index,value){
        if($("#"+value.id).hasClass('slide-activo')){
            $(this).removeClass('slide-activo');
            $(this).addClass('slide-no-activo');
            if(index == 0){
                $('.slide').last().addClass('slide-activo');
                $('.slide').last().removeClass('slide-no-activo');
            }else{
                $(this).prev().addClass('slide-activo');
                $(this).prev().removeClass('slide-no-activo');
            }
            return false;
        }
    });
}
function nextslider(){
    $.each($('.slide'), function(index,value){
        if($("#"+value.id).hasClass('slide-activo')){
            $(this).removeClass('slide-activo');
            $(this).addClass('slide-no-activo');
            if(index == $('.slide').length - 1){
                $('.slide').first().addClass('slide-activo');
                $('.slide').first().removeClass('slide-no-activo');
            }else{
                $(this).next().addClass('slide-activo');
                $(this).next().removeClass('slide-no-activo');
            }
            return false;
        }
    });
}

